import { useCallback } from 'react';

import { useLazyQuery } from '@apollo/react-hooks';

import { GetRutrConsolidatedTimeline } from 'remote/queries';

const useRollUpTheRim = () => {
  const [lazilyFetchRutrTimeline, { data = {}, loading, error }] = useLazyQuery(
    GetRutrConsolidatedTimeline,
  );

  const getRollUpTheRimTimeline = useCallback(
    (cognitoId, eventId) => {
      lazilyFetchRutrTimeline({ variables: { cognitoId, eventId } });
    },
    [lazilyFetchRutrTimeline],
  );

  const { events, count } = data.rollUpTheRimConsolidatedTimelineByTHLegacyCognitoId || {};

  return {
    loading,
    error,
    events,
    count,
    getRollUpTheRimTimeline,
  };
};

export default useRollUpTheRim;
